import {connect} from 'react-redux'

import {
    saveTimelineConfig,
    saveUserTimelineVisibility,
    fetchTimelineConfig,
    fetchUserTimelineVisibility
} from '../actions/timeline'

const mapStateToProps = ({timeline}) => {
    return timeline
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveTimelineConfig: (dashboardId, config) => {
            dispatch(saveTimelineConfig(dashboardId, config))
        },

        saveUserTimelineVisibility: (dashboardId, visible) => {
            dispatch(saveUserTimelineVisibility(dashboardId, visible))
        }
    }
}

const timelineContainer = (component) => {
    return connect(mapStateToProps, mapDispatchToProps)(component)
}

export default timelineContainer
